import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const TypeContractor = () => {
  return (
    <SettingsMetaData propertyName={"Type_Contractor"} viewPropertyName={"Type"} />
  );
};
export default TypeContractor;